import { Box } from '@mui/material';

const ColorLine = ({ color, noOffset }) => {
  return (
    <Box
      sx={{
        backgroundColor: `${color}.main`,
        width: '80%',
        height: 10,
        borderRadius: '10px',
        mb: 1,
        justifySelf: 'center'
      }}></Box>
  );
};

export default ColorLine;
